<template>
    <transiton class="" name="fade">
        <div class="container col-sm-12" v-if="showAlert">
            <div class="content">
                <div class="top clearfix">
                    <h4 >{{this.photo.type_name}}</h4>
                    <!--<a @click="colse">x</a>-->
                    <a class="" @click="colse">
                      <span >X</span>
                    </a>
                </div>
                <div class="pc-slide col-xs-12">
                    <div class="col-xs-10 view ">
                        <div class="swiper-container">
                            <a class="arrow-left" href="#"></a>
                            <a class="arrow-right" href="#"></a>
                            <div class="swiper-wrapper">
                                <div v-for="(number) in photo.album" :key="number.id" class="swiper-slide">
                                    <a target="_blank"><img :src="number.photo_urls" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="preview col-xs-2">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div v-for="(number) in photo.album" :key="number.id" class="swiper-slide">
                                    <img :src="number.photo_urls" alt="">
                                </div>
                            </div>
                            <div class="swiper-scrollbar"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transiton>
</template>

<script>
export default{
  data () {
    return {
      showAlert: false,
      photo: []
    }
  },
  methods: {
    show: function (photo) {
      this.photo = photo
      this.showAlert = true
      // console.log(photo)
    },
    colse: function () {
      this.showAlert = false
    }
  },
  updated () {
    var viewSwiper = new this.$swiper('.view .swiper-container', {

      on: {
        slideChangeTransitionStart: function () {
          updateNavPosition()
        }
      }
    })

    $('.view .arrow-left,.preview .arrow-left').on('click', function(e) {
      e.preventDefault()
      if (viewSwiper.activeIndex == 0) {
        viewSwiper.slideTo(viewSwiper.slides.length - 1, 1000);
        return
      }
      viewSwiper.slidePrev()
    })
    $('.view .arrow-right,.preview .arrow-right').on('click', function(e) {
      e.preventDefault()
      if (viewSwiper.activeIndex == viewSwiper.slides.length - 1) {
        viewSwiper.slideTo(0, 1000);
        return
      }
      viewSwiper.slideNext()
    })

    var previewSwiper = new this.$swiper('.preview .swiper-container', {
      slidesPerView: 'auto',
      direction: 'vertical',
      on: {
        tap: function () {
          viewSwiper.slideTo(previewSwiper.clickedIndex)
        }
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 80

      },
      mousewheel: {
        releaseOnEdges: true
      }
    })

    function updateNavPosition () {
      $('.preview .active-nav').removeClass('active-nav')
      var activeNav = $('.preview .swiper-slide').eq(viewSwiper.activeIndex).addClass('active-nav')
      if (!activeNav.hasClass('swiper-slide-visible')) {
        if (activeNav.index() > previewSwiper.activeIndex) {
          var thumbsPerNav = Math.floor(previewSwiper.width / activeNav.width()) - 1
          previewSwiper.slideTo(activeNav.index() - thumbsPerNav)
        } else {
          previewSwiper.slideTo(activeNav.index())
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clearfix:after{
        display: block;
        visibility: hidden;
        clear: both;
        height: 0;
        content: ".";
    }
    .clearfix{
        zoom: 1;
    }
    .container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.42);
        z-index: 1;
        transition: all .3s ease-in-out;
        overflow-y: scroll;
    }
    .content{
        border-radius: 5px;
        background: #fff;
        margin: 5% auto;
        width: 900px;
        height: 650px;

    }
    .top{
        border-bottom: 5px solid #617BE4;
    }
    .top h4{
        float: left;
        font-size: 20px;
        color: #565656;
        margin-left: 20px;
    }
    .top a{
        float: right;
        margin-top: 10px;
        margin-right: 20px;
        display: inline-block;
        /*line-height: 25px;*/
        border: 2px solid #617BE4;
        width: 25px;
        height: 25px;
        border-radius: 25px;
        color: #617BE4;
        /*font-size: 25px;*/
        text-decoration: none;
        cursor: pointer;
        text-align: center;
    }
    .top a span{
      font-size: 16px;
      margin-top: 2px;
    }
    .pc-slide {
        margin: 0 auto;
        position: relative;
    }
    .view{
        border-right: 2px solid rgba(0,0,0,0.50);
        height: 600px;
    }
    .view .swiper-container {
        padding-top: 20px;
        margin-left: 0px;
        height: 580px;
    }
    .view .swiper-slide {
      text-align: center;
    }
    .view .swiper-slide img{
        max-width: 100%;
        max-height: 100%;
    }

    .view .arrow-left {
        background:  url('arrow_left.png') no-repeat center;
        background-color: rgba(145,145,145,0.44);
        background-position: 13px;
        width:45px;
        height:45px;
        border-radius: 45px;
        position: absolute;
        left: 10px;
        top: 50%;
        margin-top: -25px;
        z-index: 10;
    }

    .view .arrow-right {
        background: url("arrow_right.png") no-repeat center ;
        background-color: rgba(145,145,145,0.44);
        background-position: 15px;
        width:45px;
        height:45px;
        border-radius: 45px;
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -25px;
        z-index: 10;
    }

    .view .arrow-left:hover,.view .arrow-right:hover{
      background-color: rgba(145,145,145,0.64);
    }

    .preview {
        margin-top: 10px;
    }

    .preview .swiper-container {
        width:140px;
        height: 580px;
    }

    .preview .swiper-slide {
        width:100%;
        height: 82px;
        cursor:pointer;
        margin-bottom: 20px;
    }

    .preview img {
        padding: 1px;
        width: 100%;
        height: 90px;
    }

    .preview .active-nav img {
        padding: 0;
        border: 3px solid #617BE4;
    }

    .preview .swiper-scrollbar{
        right: 0px;
    }


</style>



// WEBPACK FOOTER //
// src/components/titbits/albumPhoto.vue